import { FieldBase } from '@/domain/mitarbeiter/shared/components/form/fieldComponents/FieldBase';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import {
  stundenpensum,
  Stundenpensum,
} from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/stundenpensum';
import { Heading, RadioGroup, RadioGroupItem } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function StundenpensumToggle() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const { ctx } = useAnlageassistentContext();

  return (
    <div className="flex flex-col gap-4">
      <Heading>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.stundenpensum.description',
        )}
      </Heading>
      <form.AppField
        name="bezahlung.arbeitszeitkonto.gehaltsempfaenger.stundenpensum"
        listeners={{
          onChange() {
            ctx.resetDependentFields(
              'bezahlung.arbeitszeitkonto.gehaltsempfaenger.stundenpensum',
            );
          },
        }}>
        {(field) => (
          <FieldBase>
            <RadioGroup
              value={field.state.value}
              onValueChange={(val) => {
                field.handleChange(val as Stundenpensum);
              }}
              className="flex flex-row">
              <RadioGroupItem
                variant="card"
                layout="horizontal"
                label={t(
                  'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.stundenpensum.options.monat',
                )}
                value={stundenpensum.monat}
              />
              <RadioGroupItem
                variant="card"
                layout="horizontal"
                label={t(
                  'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.stundenpensum.options.woche',
                )}
                value={stundenpensum.woche}
              />
            </RadioGroup>
          </FieldBase>
        )}
      </form.AppField>
    </div>
  );
}
